import { createAction, props } from '@ngrx/store';
import { MwLoadOptions } from 'app/models/load-options.model';
import { MwPayloadModel } from 'app/models/payload.model';
import { VehicleApiModel } from 'app/models/vehicle-api.model';

export const loadVehicles = createAction(
  '[Vehicles] Load',
  props<{ loadOptions: MwLoadOptions }>()
);

export const loadVehiclesSuccess = createAction(
  '[Vehicles] Load Successful',
  props<{ response: MwPayloadModel<VehicleApiModel[]> }>()
);

export const loadVehiclesFailed = createAction(
  '[Vehicles] Load Failed',
  props<{ error: any }>()
);

export const createVehicle = createAction(
  '[Vehicles] Create',
  props<{ vehicle: VehicleApiModel }>()
);

export const createVehicleSuccess = createAction(
  '[Vehicles] Create Successful'
);

export const createVehicleFailed = createAction(
  '[Vehicles] Create Failed',
  props<{ error: any }>()
);

export const updateVehicle = createAction(
  '[Vehicles] Update',
  props<{ vehicle: VehicleApiModel }>()
);

export const updateVehicleSuccess = createAction(
  '[Vehicles] Update Successful'
);

export const updateVehicleFailed = createAction(
  '[Vehicles] Update Failed',
  props<{ error: any }>()
);

export const deleteVehicle = createAction(
  '[Vehicles] Delete',
  props<{ vehicle: VehicleApiModel }>()
);

export const deleteVehicleSuccess = createAction(
  '[Vehicles] Delete Successful'
);

export const deleteVehicleFailed = createAction(
  '[Vehicles] Delete Failed',
  props<{ error: any }>()
);

export const deleteVehiclesList = createAction(
  '[Vehicles] Delete List',
  props<{ vehicles: VehicleApiModel[] }>()
);

export const deleteVehiclesListSuccess = createAction(
  '[Vehicles] Delete List Successful'
);

export const deleteVehiclesListFailed = createAction(
  '[Vehicles] Delete List Failed',
  props<{ error: any }>()
);

export const resetVehicles = createAction('[Vehicles] Reset');
